import { apiFetch } from './client';
// The usage contract lives with the rest of `/api/sessions/*`. Two
// copies of one endpoint's shape is how it came to be wrong in the
// first place.
export { fetchUsage, sumUsage, type InstanceUsage } from './sessions';

/**
 * What the landing page needs, and nothing more.
 *
 * Three independent reads, each of which may legitimately be empty on a
 * fresh instance. The page fetches them with `Promise.allSettled`, not
 * `Promise.all`, so one absent capability cannot blank the other two.
 * The predecessor used `Promise.all` with `.catch(() => [])` on the
 * schedule call alone (`views/Dashboard.tsx:31-35`), so a failure of
 * agents, usage or insights did empty the whole view.
 */

/**
 * One slot per scheduled task (core 0.36.0). Before that the slots were a
 * table of four of the predecessor's schedules, listed on every instance
 * whether it had them or not; `tier` belonged to that table and is gone.
 */
export interface Insight {
  type: string;
  label: string;
  /** When it runs: `07:00 daily`, `08:30 Mon, Thu`, `21:00 on 2026-05-07`. */
  schedule: string;
  available: boolean;
}

export interface ScheduleExecution {
  id?: number;
  procedure_name?: string;
  scheduled_for_ms?: number | null;
  started_at_ms?: number | null;
  finished_at_ms?: number | null;
  status?: string;
  error?: string | null;
}

export function fetchInsights(): Promise<Insight[]> {
  return apiFetch<Insight[]>('/api/insights');
}

export function fetchScheduleExecutions(
  limit = 10,
): Promise<ScheduleExecution[]> {
  return apiFetch<ScheduleExecution[]>(
    `/api/schedule/executions?limit=${limit}`,
  );
}
